import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal } from '../../shared'

@Component({
    templateUrl: './days-calc.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class DaysCalcComponent extends BaseModal {
    faSpinner = faSpinner
    target: any
    days = 0
    anchorDate = new Date().date()

    get calcDate(): Date {
        return this.anchorDate.addDays(this.days)
    }

    get title() {
        return 'Calculate Completion Date for ' + this.target.bidDescription
    }
}
